/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VwFormInfoWithRelations } from '../models/vw-form-info-with-relations';

@Injectable({
  providedIn: 'root',
})
export class VwFormInfoControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation vwFormInfoControllerFindFormData
   */
  static readonly VwFormInfoControllerFindFormDataPath = '/vw-form-infos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findFormData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findFormData$Response(params?: {
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<Array<VwFormInfoWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, VwFormInfoControllerService.VwFormInfoControllerFindFormDataPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VwFormInfoWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findFormData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findFormData(params?: {
    context?: HttpContext
    body?: {
}
  }
): Observable<Array<VwFormInfoWithRelations>> {

    return this.findFormData$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VwFormInfoWithRelations>>) => r.body as Array<VwFormInfoWithRelations>)
    );
  }

}
